import { mutate as globalMutate } from 'swr';

function chronologyListKey(matterGuid: string): string {
  return `/matters/${matterGuid}/chronologies`;
}

function chronologyEventsKey(matterGuid: string, chronologyId: string): string {
  return `/matters/${matterGuid}/chronologies/${chronologyId}/events`;
}

function chronologyTagsKey(matterGuid: string, chronologyId: string): string {
  return `/matters/${matterGuid}/chronologies/${chronologyId}/tags`;
}

function chronologyVersionsKey(matterGuid: string, chronologyId: string): string {
  return `/matters/${matterGuid}/chronologies/${chronologyId}/versions`;
}

function allChronologyEventsKey(matterGuid: string): string {
  return `/matters/${matterGuid}/chronology-events`;
}

function isChronologyEventsKey(
  key: unknown,
  matterGuid: string,
  chronologyId?: string,
): key is string {
  if (typeof key !== 'string') return false;
  if (key === allChronologyEventsKey(matterGuid)) return true;
  if (chronologyId) return key === chronologyEventsKey(matterGuid, chronologyId);
  return key.startsWith(`/matters/${matterGuid}/chronologies/`) && key.endsWith('/events');
}

function isChronologyTagsKey(
  key: unknown,
  matterGuid: string,
  chronologyId?: string,
): key is string {
  if (typeof key !== 'string') return false;
  if (chronologyId) return key === chronologyTagsKey(matterGuid, chronologyId);
  return key.startsWith(`/matters/${matterGuid}/chronologies/`) && key.endsWith('/tags');
}

function isChronologyVersionsKey(key: unknown, matterGuid: string): key is string {
  return typeof key === 'string'
    && key.startsWith(`/matters/${matterGuid}/chronologies/`)
    && key.endsWith('/versions');
}

export function revalidateChronologyVersions(
  matterGuid: string,
  chronologyId?: string,
): Promise<unknown> {
  if (chronologyId) {
    return globalMutate(chronologyVersionsKey(matterGuid, chronologyId));
  }
  return globalMutate((key) => isChronologyVersionsKey(key, matterGuid));
}

export function revalidateChronologyEvents(
  matterGuid: string,
  chronologyId?: string,
): Promise<unknown> {
  return globalMutate((key) => isChronologyEventsKey(key, matterGuid, chronologyId));
}

export function revalidateChronologyTags(
  matterGuid: string,
  chronologyId?: string,
): Promise<unknown> {
  return globalMutate((key) => isChronologyTagsKey(key, matterGuid, chronologyId));
}

export function revalidateChronologyList(matterGuid: string): Promise<unknown> {
  return globalMutate(chronologyListKey(matterGuid));
}

export function revalidateChronologyData(
  matterGuid: string,
  chronologyId?: string,
): Promise<unknown[]> {
  return Promise.all([
    revalidateChronologyList(matterGuid),
    revalidateChronologyEvents(matterGuid, chronologyId),
    revalidateChronologyTags(matterGuid, chronologyId),
    revalidateChronologyVersions(matterGuid, chronologyId),
  ]);
}
